import React from 'react';
import PortfolioTitle from '../../Utilities/PortfolioTitle'

// material
import Grid from '@material-ui/core/Grid'

// Images
import DevelopmentImg from '../../../assets/portfolio/AppDevelopment/DevelopmentApps.png'
export default class AppDevelopment extends React.Component{
 render(){
  return(
  	<section>
  		<div className="container PortfolioItem" style={{marginBottom: 80, }}>
  			<Grid container alignItems="flex-center">
  				<Grid item className="AppDevelopmentImage">
					<img style={{maxHeight: 80}} src={DevelopmentImg} alt=""/>
  				</Grid>
  				<Grid item>
					<PortfolioTitle colorTitle="#4D88FF" colorSubtitle="#595959" title="App Development" subtitle="Mobile, Desktop & Web Application Development"/>
  				</Grid>
  			</Grid>
  		</div>
  	</section>
  );
 }
}


// WEBPACK FOOTER //
// ./src/Components/Portfolio/AppDevelopment/AppDevelopment.js